import ResponsiveContext from "./ResponsiveContext";

export default ResponsiveContext.Consumer;